import "./TnCText.scss";

const TncText = ({ onClick }) => {
  return (
    <div className="tnc-text-wrapper">
      <span>By continuing, you agree to our&nbsp;</span>
      <span
        className="modal-trigger"
        onClick={onClick}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          color: "#FB4764",
        }}
      >
        Terms & Conditions
      </span>
    </div>
  );
};

export default TncText;
